import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";

import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

import bgFront from "assets/images/rotating-card-bg-front.jpg";
import bgBack from "assets/images/rotating-card-bg-back.jpg";
import MKBadge from "components/MKBadge";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={6}
          flexDirection="column"
          alignItems="center"
          sx={{ textAlign: "center", my: 6, mx: "auto", px: 0.75 }}
        >
          <MKBadge
            variant="contained"
            color="success"
            badgeContent="Chess for All"
            container
            sx={{ mb: 2 }}
          />
          <MKTypography variant="h3" fontWeight="bold">
            Enroll in our Certified Learning Programs
          </MKTypography>
          <MKTypography variant="body1" color="text">
            Engage in our Certified Learning Programs designed to enhance your skills and knowledge.
            From expert-led courses to hands-on workshops, unlock your full potential with us.
          </MKTypography>
        </Grid>
      </Container>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}

                icon="touch_app"
                title={
                  <>
                    Enroll yourself
                    <br />
                    and become the member of IM Chess
                  </>
                }
                description="Flip me to view more related coaurses"
              />
              <RotatingCardBack
                image={bgBack}
                title="Discover More"
                description="You will get all the list of available courses including online and offline."
                action={{
                  type: "internal",
                  route: "/batch/online",
                  label: "View All Courses",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <h2>♟</h2>
                <DefaultInfoCard
                  // icon="content_copy"
                  title="Beginner"
                  description="We’ve curated chess from scratch with expert-designed lessons to build a strong foundation."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <h2>♞</h2>
                <DefaultInfoCard
                  // icon="flip_to_front"
                  title="Intermediate"
                  description="We’ve crafted advanced tactics and strategies to sharpen your gameplay and thinking."
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <h2>♚</h2>
                <DefaultInfoCard
                  // icon="price_change"
                  title="Advanced"
                  description="We’ve designed deep training sessions to master openings, endgames, and tournament preparation."
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="devices"
                  title="Individual"
                  description="We’ve personalized one-on-one sessions to accelerate growth and refine your skills."
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;